const DEFAULT_RADIO_VALUE = 'full'

/* @ngInject */
const myWagonRailwaySearch = (
  valueHandler,
  $$railway,
  $$area
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      restrictSearch: '=',
    },
    template: require('./myWagonRailwaySearch.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.railwayRadios = [{
        label: 'Sur une voie',
        id: 'onRailway',
        value: 'full',
      }, {
        label: 'Sur aucune voie',
        id: 'outRailway',
        value: 'empty',
      }, {
        label: 'Les deux',
        id: 'bothRailway',
        value: 'any',
      },]

      if (valueHandler.isObject($scope.restrictSearch) && $scope.restrictSearch.railwayIdNull === 'full') {
        $scope.disableRadioButtons = true
      }
    },
    link: {
      pre: async (scope, element, attrs) => {
        scope.myWagon = scope.myWagon || {}
        scope.myWagon.railwayIdNull = scope.myWagon.railwayIdNull || DEFAULT_RADIO_VALUE
        if (scope.myWagon.railwayId) {
          scope.myRailway = await $$railway.request.getById(scope.myWagon.railwayId)
        }
        if (scope.myWagon.areaId) {
          scope.myArea = await $$area.request.getById(scope.myWagon.areaId)
        }
      },
      post: (scope, element, attrs, ctrl) => {
        scope.$watch('myWagon.railwayIdNull', (newValue, oldValue) => {
          if (oldValue !== newValue) {
            if (newValue === 'any' || newValue === 'empty') {
              scope.myWagon.railwayId = undefined
              scope.myWagon.areaId = undefined
            } else if (newValue === 'full') {
              if (valueHandler.isObject(scope.myRailway)) {
                scope.myWagon.railwayId = scope.myRailway.id
              }
              if (valueHandler.isObject(scope.myArea)) {
                scope.myWagon.areaId = scope.myArea.id
              }
            } else {
              if (valueHandler.isObject(scope.myWagon)) {
                scope.myWagon.railwayIdNull = DEFAULT_RADIO_VALUE
              }
            }
          }
        })

        scope.$watch('myWagon', (newValue, oldValue) => {
          if (oldValue !== newValue) {
            if (valueHandler.isObject(newValue) && valueHandler.isEmpty(newValue.railwayIdNull)) {
              newValue.railwayIdNull = DEFAULT_RADIO_VALUE
            }
          }
        })

        scope.$watch('myWagon.railwayId', async (newValue, oldValue) => {
          if (valueHandler.isId(newValue) && newValue !== oldValue) {
            scope.myRailway = await $$railway.request.getById(scope.myWagon.railwayId)
          } else {
            scope.myRailway = undefined
          }
        }, true)

        scope.$watch('myWagon.areaId', async (newValue, oldValue) => {
          if (valueHandler.isId(newValue) && newValue !== oldValue) {
            scope.myArea = await $$area.request.getById(scope.myWagon.areaId)
          } else {
            scope.myArea = undefined
          }
        }, true)

        scope.$watch('myRailway', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            if (valueHandler.isObject(newValue) && valueHandler.isId(newValue.id)) {
              scope.myWagon.railwayId = newValue.id
            } else {
              scope.myWagon.railwayId = undefined
            }
          }
        })

        scope.$watch('myArea', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            if (valueHandler.isObject(newValue) && valueHandler.isId(newValue.id)) {
              scope.myWagon.areaId = newValue.id
            } else {
              scope.myWagon.areaId = undefined
            }
          }
        })
      },
    },
  }
}
export default myWagonRailwaySearch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonRailwaySearch.js